import createMessage from "./createMessage";
import DataRemoteSettings from "../private/DataRemoteSettings";

const name = "remoteSettings";

function create(remoteSettings) {
  return createMessage({
    [name]: DataRemoteSettings.create(remoteSettings)
  });
}

export default {
  create,
  name
};

// Avatar avatar = 1;
// MicSensitivity micSensitivity = 2;
// repeated MicSensitivity supportedSensitivities = 3;
// MotionDetectionSensitivity motionDetectionSensitivity = 4;
